import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { ANIMATIONS, TIME_TO_SLIDE } from '@app/constants/animations.constants';
import { AppFacade } from '@app/app.facade';
import { Countries } from '@ux/entities/country.enum';
import { environment } from '@environment';
import { SpecialInfoTypes } from '@booking/constants/special-info-types';
import { TermsAndConditionsEntity } from '@app/entities/terms-and-conditions';
import { AssetTerm } from '@asset-terms';
import { MobileDeviceService } from '@app/services/mobile-device.service';

@Component({
  selector: 'app-special-travel-data.component',
  templateUrl: './special-travel-data.component.html',
  styleUrls: ['./special-travel-data.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SpecialTravelDataComponent {

  public animation: string = ANIMATIONS.SLIDE_IN_RIGHT;
  public booking: string = 'booking';
  public infoType: SpecialInfoTypes = SpecialInfoTypes.CASHBACK;

  constructor(
    private facade: AppFacade,
    private router: Router,
    private mobileDeviceService: MobileDeviceService,
  ) {
    const extras = this.router.getCurrentNavigation()?.extras;
    if (extras && extras.state && extras.state.infoType) this.infoType = extras.state.infoType;
  }

  get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }
  
  get countries(): typeof Countries {
    return Countries;
  }

  get country(): string {
    return environment.countryInfo.iso_code;
  }

  get assetTermCashback(): TermsAndConditionsEntity {
    return AssetTerm.CASHBACK_TRAVEL;
  }

  get assetTermCashback30(): TermsAndConditionsEntity {
    return AssetTerm.CASHBACK_30_TRAVEL;
  }

  get assetTermELO(): TermsAndConditionsEntity {
    return AssetTerm.ELO_TRAVEL;
  }

  get assetTermLIVELO(): TermsAndConditionsEntity {
    return AssetTerm.LIVELO_TRAVEL;
  }

  get assetTermTudoAzul(): TermsAndConditionsEntity {
    return AssetTerm.TUDO_AZUL_TRAVEL;
  }

  get assetTermPontosDotz(): TermsAndConditionsEntity {
    return AssetTerm.PONTOS_DOTZ_TRAVEL;
  }

  get assetTermRappiCard(): TermsAndConditionsEntity {
    return AssetTerm.RAPPICARD_TERMS;
  }

  get assetTermHotelsAndCars(): TermsAndConditionsEntity {
    return AssetTerm.CASHBACK_HOTEL_CARS;
  }

  get assetBlackFridayTravel(): TermsAndConditionsEntity {
    return AssetTerm.BLACK_FRIDAY;
  }

  get assetTermInstallments(): TermsAndConditionsEntity {
    return AssetTerm.INSTALLMENTS;
  }
  
  get assetTermBlackWeekend(): TermsAndConditionsEntity {
    return AssetTerm.BLACK_WEEKEND;
  }

  get assetTermHotelsOffTravelTerms(): TermsAndConditionsEntity {
    return AssetTerm.HOTELS_OFF_TRAVEL;
  }

  get assetTermGyraTravesia(): TermsAndConditionsEntity {
    return AssetTerm.GYRA_TRAVESIA;
  }

  get assetTermPreviajeII(): TermsAndConditionsEntity {
    return AssetTerm.PREVIAJE_II;
  }

  get assetChubbTerms(): TermsAndConditionsEntity {
    return AssetTerm.CHUBB_TERMS;
  }

  get assetCivitatisTerms(): TermsAndConditionsEntity {
    return AssetTerm.CIVITATIS_TERMS;
  }

  get assetDiviviendaTerms(): TermsAndConditionsEntity {
    return AssetTerm.DAVIVIENDA;
  }

  get assetRappiTravelTerms(): TermsAndConditionsEntity {
    return AssetTerm.RAPPI_TRAVEL;
  }

  get assetHotel5PerTerms(): TermsAndConditionsEntity {
    return AssetTerm.HOTELS_5_PER;
  }

  get assetDutyFreeTerms(): TermsAndConditionsEntity {
    return AssetTerm.DUTY_FREE;
  }

  get isBookingRoute(): boolean {
    return this.router.url.includes(this.booking);
  }

  get specialInfoTypes(): typeof SpecialInfoTypes {
    return SpecialInfoTypes;
  }

  public goBack(): void {
    this.animation = ANIMATIONS.SLIDE_OUT_RIGHT;
    setTimeout(() => this.facade.navigateToLastRoute(), TIME_TO_SLIDE);
  }

}
